import { render, staticRenderFns } from "./bulma_field_context.vue?vue&type=template&id=bb590560&scoped=true&lang=html"
import script from "./bulma_field_context.vue?vue&type=script&lang=js"
export * from "./bulma_field_context.vue?vue&type=script&lang=js"
import style0 from "./bulma_field_context.vue?vue&type=style&index=0&id=bb590560&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb590560",
  null
  
)

export default component.exports